import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface AssistantRequest {
  archive_id?: string;
  archive_ids?: string[];
  task?: 'extraction' | 'classify';
  language?: string;
  clear_delfos_cache?: boolean;
  clear_di2winocr_cache?: boolean;
  delfos_llm_config_id?: string;
  ocr_features_config_id?: string;
}

export interface AssistantResult {
  wishList: any[];
  generalRules: string[];
  generalQuestions: any[];
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AssistantService {
  private baseUrl = '/api/assistant';

  constructor(private http: HttpClient) { }

  generateExtractionModel(archiveId: string, language: string = 'pt'): Observable<AssistantResult> {
    return this.generateModel(archiveId, 'extraction', language);
  }

  generateModel(
    archiveIds: string | string[],
    task: 'extraction' | 'classify' = 'extraction',
    language: string = 'pt',
    clearDelfosCache: boolean = false,
    clearOcrCache: boolean = false,
    ocrFeaturesConfigId?: string,
    delfosLlmConfigId?: string
  ): Observable<any> {
    const ids = Array.isArray(archiveIds) ? archiveIds : [archiveIds];
    const body: AssistantRequest = {
      archive_id: ids[0],
      archive_ids: ids,
      task,
      language,
      clear_delfos_cache: clearDelfosCache,
      clear_di2winocr_cache: clearOcrCache,
      ...(ocrFeaturesConfigId ? { ocr_features_config_id: ocrFeaturesConfigId } : {}),
      ...(delfosLlmConfigId ? { delfos_llm_config_id: delfosLlmConfigId } : {})
    };

    return this.http.post<any>(`${this.baseUrl}/helper`, body);
  }
}
